export const SET_DATE_FILTER = 'ui/SET_DATE_FILTER';
export const TOGGLE_CONTRIB = 'ui/TOGGLE_CONTRIB';
export const SET_VISIBLE_RECIPIENT = 'ui/SET_VISIBLE_RECIPIENT';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const EXPIRE_SESSION = 'ui/EXPIRE_SESSION';
export const RESET_UI = 'ui/RESET_UI';
